export interface FlyerStyleConfig {
  color?: string;
  fontName?: string;
  fontSize?: number;
  isItalic?: boolean;
  alignment?: 'left' | 'center' | 'right' | string;
  fontWeight?: 'regular' | 'bold' | string;
  shadowRadius?: number;
  letterSpacing?: number;
  [k: string]: unknown;
}

export interface FlyerFieldConfig {
  id: string;
  type: string; // 'Text'
  label: string;
  x_percent: number;
  y_percent: number;
  width_percent: number;
  height_percent: number;
  style_config: FlyerStyleConfig;
  placeholder?: string;
  auto_fill_enabled?: boolean;
  auto_fill_source?: string;
  /** Serve-time only (GET detail of a program-bound template). Never sent on write. */
  default_text?: string;
}

export interface FlyerCategory {
  id: string;
  name_json: Record<string, string>;
  sort_order: number;
  color: string | null;
}

export type FlyerCategoryInput = Partial<Pick<FlyerCategory, 'name_json' | 'sort_order' | 'color'>>;

export interface FlyerTemplate {
  id: string;
  category_id: string;
  name_json: Record<string, string>;
  width: number;
  height: number;
  fields_config: FlyerFieldConfig[];
  sort_order: number;
  is_active: boolean;
  source_topic_no: string | null;
  preview_image_url: string | null;
  background_image_url: string | null;
  created_at: string;
  updated_at: string;
}

export type FlyerTemplateInput = Partial<
  Pick<FlyerTemplate, 'category_id' | 'name_json' | 'width' | 'height' | 'fields_config' | 'sort_order' | 'is_active' | 'source_topic_no'>
>;

/** Mirror of the backend TOPIC_AUTOFILL_SOURCES catalog (flyer-autofill.js). */
export const TOPIC_AUTOFILL_SOURCES = [
  'topic.title', 'topic.body', 'topic.rate', 'topic.apr', 'topic.rate_as_of', 'topic.investor',
] as const;

export const PROFILE_AUTOFILL_SOURCES = [
  'profile.mlo_info.name', 'profile.mlo_info.phone', 'profile.mlo_info.email', 'profile.mlo_info.nmls_id',
] as const;
